module.exports = __webpack_public_path__ + "static/media/specialization.8b4bb5bb.svg";